module.exports = __webpack_public_path__ + "img/33.935a63d1.png";